__turbopack_context__.v({
  "box": "checkbox-module-scss-module__-gxYhG__box",
  "default": "checkbox-module-scss-module__-gxYhG__default",
  "description": "checkbox-module-scss-module__-gxYhG__description",
  "destructive": "checkbox-module-scss-module__-gxYhG__destructive",
  "disabled": "checkbox-module-scss-module__-gxYhG__disabled",
  "error": "checkbox-module-scss-module__-gxYhG__error",
  "indicator": "checkbox-module-scss-module__-gxYhG__indicator",
  "label": "checkbox-module-scss-module__-gxYhG__label",
  "label_wrapper": "checkbox-module-scss-module__-gxYhG__label_wrapper",
  "root": "checkbox-module-scss-module__-gxYhG__root",
  "success": "checkbox-module-scss-module__-gxYhG__success",
  "warning": "checkbox-module-scss-module__-gxYhG__warning",
});
